import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/clock-normal.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-ff389794")

_pushScopeId("data-v-ff389794")
const _hoisted_1 = { class: "day-label flex-shrink-0" }
const _hoisted_2 = { class: "flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:items-center" }
const _hoisted_3 = { class: "flex min-w-0 flex-1 flex-wrap items-center gap-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-4 w-4",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "relative flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text-lg leading-none" }, "+", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_TimeSlotChip = _resolveComponent("TimeSlotChip")!
  const _component_PickupTimePopover = _resolveComponent("PickupTimePopover")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    "data-testid": `pickup-schedule-config-day-row-${_ctx.day}`,
    class: ["flex flex-col gap-3 bg-white px-3 py-2.5 md:flex-row md:items-center", [
      _ctx.day === 'monday' ? '' : 'border-t border-gray-lp-1600',
      _ctx.enabled ? '' : 'text-gray-lp-500'
    ]]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_CheckboxV2, {
        value: _ctx.checked,
        disabled: !_ctx.enabled,
        label: _ctx.dayLabel,
        keyName: `pickup-schedule-config-checkbox-day-${_ctx.day}`,
        "data-testid": `pickup-schedule-config-checkbox-day-${_ctx.day}`,
        className: _ctx.enabled ? 'schedule-checkbox' : 'p-field-checkbox-grey',
        labelWeight: "normal",
        textSize: 14,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:checked', $event)))
      }, null, 8, ["value", "disabled", "label", "keyName", "data-testid", "className"])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slots, (slot, index) => {
          return (_openBlock(), _createBlock(_component_TimeSlotChip, {
            key: `${slot.start}-${slot.end}`,
            timeSlot: slot,
            disabled: _ctx.controlsDisabled,
            "data-testid": `pickup-schedule-config-time-chip-${_ctx.day}-${index}`,
            onRemove: ($event: any) => (_ctx.removeSlot(index))
          }, null, 8, ["timeSlot", "disabled", "data-testid", "onRemove"]))
        }), 128)),
        (!_ctx.slots.length)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              "data-testid": `pickup-schedule-config-empty-slots-${_ctx.day}`,
              class: "flex items-center gap-1.5 text-sm text-gray-lp-500"
            }, [
              _hoisted_4,
              _createVNode("span", null, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.emptySlots")), 1)
            ], 8, ["data-testid"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          type: "button",
          "data-testid": `pickup-schedule-config-button-add-time-${_ctx.day}`,
          class: ["flex w-full items-center justify-center gap-1 rounded-lg border px-3 py-2 text-sm font-medium sm:w-auto", 
            _ctx.addTimeDisabled
              ? 'cursor-not-allowed border-gray-lp-400 text-gray-lp-500'
              : 'schedule-active-color'
          ],
          disabled: _ctx.addTimeDisabled,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAddTime && _ctx.openAddTime(...args)))
        }, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.addTime")), 1)
        ], 10, ["data-testid", "disabled"]),
        _createVNode(_component_PickupTimePopover, {
          open: _ctx.popoverOpen,
          day: _ctx.day,
          existingSlots: _ctx.slots,
          selectedStart: _ctx.selectedStart,
          slotStartHour: _ctx.slotStartHour,
          slotEndHour: _ctx.slotEndHour,
          slotIntervalMinutes: _ctx.slotIntervalMinutes,
          "onUpdate:open": _ctx.onPopoverVisibility,
          "onUpdate:selectedStart": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedStart = $event)),
          onConfirm: _ctx.addSlot
        }, null, 8, ["open", "day", "existingSlots", "selectedStart", "slotStartHour", "slotEndHour", "slotIntervalMinutes", "onUpdate:open", "onConfirm"])
      ])
    ])
  ], 10, ["data-testid"])), [
    [_directive_click_outside, _ctx.closePopover]
  ])
})